






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
    };
  },
  methods: {
    makeTableOptions() {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
          "show-select": true,
        },
        content: {
          name: "Quản lý KOC",
          urlEnabled: true,
          search: {},
          displayFields: {
            name: {
              text: "Tên",
              sortable: true,
            },
            channelUrl: {
              text: "Link kênh",
              sortable: true,
              options: {
                textMaxWidth: "200px",
              },
            },
            creatorChannelType: {
              text: "Loại kênh",
              options: {
                subProp: "creatorChannelType.name",
                sortBy: "creatorChannelTypeId",
                label: true,
              },
            },
            users: userManager.checkRole(["kt"]) && {
              text: "Users",
              options: {
                labelItems: (u) => u.name,
              },
            },
            ownerUser: userManager.checkRole(["kt", "mkt"]) && {
              text: "Chủ sở hữu kênh",
              options: {
                subProp: "ownerUser.name",
                label: true,
              },
            },
            description: {
              text: "Mô tả",
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["kt"]) && {
              target: {
                dialog: {
                  attrs: {
                    width: "600px",
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt", "mkt", "tp"]) && {
                target: {
                  dialog: {
                    attrs: {
                      width: "600px",
                    },
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "marketId",
              operator: "equal_to",
              value: this.context().$route.params.marketId,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("creators", "findAll", options);
              return [items, count];
            },
            async insert(item, dataTable) {
              item.marketId = dataTable.context().$route.params.marketId;
              return await coreApiClient.call("creators", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "creators",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("creators", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              channelUrl: {
                attrs: {
                  label: "Link kênh",
                  required: true,
                },
              },
              creatorChannelTypeId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Loại kênh",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("creatorChannelTypes", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              ownerUserId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Chủ sở hữu kênh",
                  "item-value": "_id",
                  "item-text": "name",
                  clearable: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const filters = [];
                        if (value) {
                          filters.push({ key: "_id", operator: "equal_to", value });
                        }
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({ search, limit, filters }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
            },
            insertForm: {
              content: {
                fieldNames: ["name", "channelUrl", "creatorChannelTypeId", "description"],
              },
            },
            editForm: {
              content: {
                fieldNames: ["channelUrl", "creatorChannelTypeId", "description", "ownerUserId"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      };
    },
  },
  async created() {
    this.tableOptions = this.makeTableOptions();
  },
});
